import { useState } from "react";
import type { HoldReason } from "@shared/types";

const REASONS: { id: HoldReason; label: string }[] = [
  { id: "prescriber_callback", label: "Waiting on prescriber callback" },
  { id: "insurance",           label: "Insurance / prior auth issue" },
  { id: "patient_callback",    label: "Waiting on patient callback" },
  { id: "other",               label: "Other" },
];

type Props = {
  onConfirm: (reason: HoldReason, note: string) => void;
  onCancel: () => void;
};

export function HoldDialog({ onConfirm, onCancel }: Props) {
  const [reason, setReason] = useState<HoldReason>("prescriber_callback");
  const [note, setNote] = useState("");

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-surface rounded-lg shadow-xl w-[420px] p-5">
        <h2 className="text-lg font-semibold mb-1">Put this Rx on hold</h2>
        <p className="text-ink-soft text-sm mb-4">It'll move to the On Hold queue until someone resumes it.</p>

        <div className="flex flex-col gap-2 mb-4">
          {REASONS.map((r) => (
            <label key={r.id} className="flex items-center gap-2 text-sm cursor-pointer">
              <input
                type="radio"
                name="hold-reason"
                value={r.id}
                checked={reason === r.id}
                onChange={() => setReason(r.id)}
              />
              {r.label}
            </label>
          ))}
        </div>

        <label className="block text-xs text-ink-soft mb-1">Note (optional)</label>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="What are we waiting for?"
          className="w-full px-2.5 py-1.5 border border-border rounded text-sm min-h-[64px] resize-y mb-4"
        />

        <div className="flex justify-end gap-2">
          <button type="button" onClick={onCancel} className="px-3 py-1.5 border border-border rounded text-sm">
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(reason, note)}
            className="px-3 py-1.5 bg-warn text-white rounded text-sm font-medium"
          >
            Hold Rx
          </button>
        </div>
      </div>
    </div>
  );
}
